import type { ColumnGroupPreferenceState, ColumnPreferenceState } from 'components/shared/Blotter/Grid/blotter.model';
import type { IBlotterPriceImprovementItem } from 'models/IBlotterItem';
import type { Thunk } from 'state/state.common';

import {
  priceImprovementBlotterColumnStateChanged,
  priceImprovementBlotterDetailClosed,
  priceImprovementBlotterDetailOpened,
  priceImprovementBlotterItemsPerPageChanged,
  priceImprovementBlotterPreferenceStatePersisted,
  priceImprovementBlotterSelectionChanged,
} from './priceImprovementBlotter.action';

export function priceImprovementBlotterItemsPerPageChangedThunk(itemsPerPage: number): Thunk<void> {
  return (
    dispatch,
    getState,
    {
      selectors: {
        priceImprovementBlotter: { getBlotterPreferenceState },
      },
    },
  ) => {
    const state = getState();
    const blotterPreferenceState = getBlotterPreferenceState(state);

    dispatch(priceImprovementBlotterItemsPerPageChanged(itemsPerPage));
    dispatch(priceImprovementBlotterPreferenceStatePersisted(blotterPreferenceState));
  };
}
export function priceImprovementBlotterColumnStateChangedThunk(
  columnState: readonly ColumnPreferenceState[],
  columnGroupState?: readonly ColumnGroupPreferenceState[],
): Thunk<void> {
  return (
    dispatch,
    getState,
    {
      selectors: {
        priceImprovementBlotter: { getBlotterPreferenceState },
      },
    },
  ) => {
    const state = getState();
    const blotterPreferenceState = getBlotterPreferenceState(state);

    dispatch(priceImprovementBlotterColumnStateChanged(columnState, columnGroupState));
    dispatch(
      priceImprovementBlotterPreferenceStatePersisted({ ...blotterPreferenceState, columnState, columnGroupState }),
    );
  };
}

export function priceImprovementBlotterSelectionChangedThunk(
  selectedItems: readonly IBlotterPriceImprovementItem[],
): Thunk<void> {
  return dispatch => {
    dispatch(priceImprovementBlotterSelectionChanged(selectedItems.map(item => item.id)));
    if (selectedItems.length === 1) {
      dispatch(priceImprovementBlotterDetailOpened(selectedItems[0]));
    } else {
      dispatch(priceImprovementBlotterDetailClosed());
    }
  };
}

export function priceImprovementBlotterDetailClosedThunk(): Thunk<void> {
  return dispatch => {
    dispatch(priceImprovementBlotterSelectionChanged([]));
    dispatch(priceImprovementBlotterDetailClosed());
  };
}
